import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getTenants } from './actions'
import { applySpec, prop, pipe } from 'ramda'

export const withTenants = WrappedComponent => {
  class WithTenants extends Component {
    componentDidMount () {
      this.props.getTenants()
    }

    render () {
      return <WrappedComponent tenants={this.props.tenants} {...this.props} />
    }
  }

  WithTenants.propTypes = {
    getTenants: PropTypes.func.isRequired,
    tenants: PropTypes.array.isRequired
  }

  return WithTenants
}

export default pipe(
  withTenants,
  connect(
    applySpec({
      tenants: prop('tenants')
    }),
    {
      getTenants
    }
  )
)



// WEBPACK FOOTER //
// ./src/components/with-tenants/container/index.js